<template>
  <div v-show="showAlerts" class="alert-bubbles-wrapper">
    <div v-if="errorMessage" class="error-message">{{errorMessage}}</div>
    <loading-icon v-if="isLoading"/>
    <div v-else class="alerts-wrapper">
      <div v-for="(alert, index) in filteredAlerts" :key="index" class="alert">
        <h4 class="header">{{alert.header}}</h4>
        <p class="content" v-html="alert.content"/>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingIcon from "./LoadingIcon.vue"
import { brandsAPI } from "../../services/api/brands"

export default {
  props: {
    currentAdvertiser: Object
  },

  name: "AlertBubbles",

  components: {
    LoadingIcon
  },

  data() {
    return {
      alerts: [],
      errorMessage: null,
      displayAlertPages: ['dashboard', 'files', 'credits', 'settings'],
      isLoading: false
    }
  },

  computed: {
    currentRouteName: function () {
      return this.$route.name?.toLowerCase()
    },
    showAlerts: function () {
      const isDisplayPage = this.displayAlertPages.includes(this.currentRouteName),
            hasAlerts = this.filteredAlerts?.length > 0
      return isDisplayPage && (this.isLoading || hasAlerts)
    },
    filteredAlerts: function () {
      return this.alerts?.filter(alert => alert.page === this.currentRouteName || !alert.page)
    }
  },

  async created() {
    await this.getAlerts()
  },

  methods: {
    getAlerts() {
      this.isLoading = true
      this.errorMessage = null

      brandsAPI.fetchAlerts(this.currentAdvertiser.id)
        .then((data) => {
          this.alerts = data
        })
        .catch(e => this.errorMessage = e)
        .finally(() => this.isLoading = false)
    }
  }
}
</script>

<style lang="sass">
@import "../../assets/sass/colors"

.alert-bubbles-wrapper
  background-color: $primary-transparent
  border-radius: 8px
  font: unset
  margin: .5em auto 0
  padding:  10px
  overflow: auto
  text-align: center
  width: 55%
  .loading-icon
    margin: 1rem auto
  .alert:not(:last-child)
    margin-bottom: 10px
  .header
    -webkit-text-stroke-width: 1px
    margin-bottom: 4px
  .content
    *
      font-size: .9em
    b
      font-weight: bold
    p:not(:last-child)
      margin-bottom: 4px
    i
      font-style: italic
  a
    color: $primary-color
    font-weight: bold
</style>